import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/portfolio-next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/portfolio-next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/portfolio-next/src/assets/projects/mockly-dashboard.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/portfolio-next/src/assets/projects/rag-sql-chatbot-accuracy.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/portfolio-next/src/assets/projects/smart-parking-dashboard.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/portfolio-next/src/components/sections/Footer.jsx");
